// extracted by mini-css-extract-plugin
module.exports = {"not_found":"business-list_not_found__xa2y-"};